import React from "react";
import styles from "./AppSidebar.module.css";
import { useUIStore } from "@store";
import ConversationHistory from "../chat/ConversationHistory";
import { trackEvent } from "../../services/analyticsService";
import { useChatStore } from "@store";
import {
  HomeIcon,
  DocumentsIcon,
  PromptsIcon,
  BrainIcon,
  PlusIcon,
  RobotIcon,
} from "../common/Icons";
import MindspaceSelector from "../common/MindspaceSelector";
import useMediaQuery from "../../hooks/useMediaQuery";

const AppSidebar: React.FC = () => {
  const { route, navigate } = useUIStore();
  const startNewChatSession = useChatStore((s) => s.startNewChatSession);

  const handleNav = (nextRoute: Parameters<typeof navigate>[0]) => {
    navigate(nextRoute);
    trackEvent("nav_clicked", { route: nextRoute });
  };

  return (
    <div className={styles.sidebarRoot}>
      <header className={styles.header}>
        <div className={styles.brand}>
          <RobotIcon className={styles.navIcon} title="Smartie AI" />
          <span>Smartie AI (beta)</span>
        </div>
      </header>

      <ul className={styles.navList} role="list">
        <li>
          <button
            className={`${styles.navItem} ${styles.primary}`}
            onClick={() => {
              startNewChatSession();
              const sid = useChatStore.getState().sessionId;
              navigate("chat", { sessionId: sid });
              trackEvent("nav_clicked", {
                route: "chat",
                source: "new_chat_nav",
              });
            }}
          >
            <PlusIcon className={styles.navIcon} title="Chat nou" />
            Chat nou
          </button>
        </li>
        <li>
          <button
            className={styles.navItem}
            aria-current={route === "welcome" ? "page" : undefined}
            onClick={() => handleNav("welcome")}
          >
            <HomeIcon className={styles.navIcon} title="Bun venit" />
            Bun venit
          </button>
        </li>
        <li>
          <button
            className={styles.navItem}
            aria-current={route === "documents" ? "page" : undefined}
            onClick={() => handleNav("documents")}
          >
            <DocumentsIcon className={styles.navIcon} title="Documente" />
            Documente
          </button>
        </li>
        <li>
          <button
            className={styles.navItem}
            aria-current={route === "prompts" ? "page" : undefined}
            onClick={() => handleNav("prompts")}
          >
            <PromptsIcon className={styles.navIcon} title="Prompturi" />
            Prompturi
          </button>
        </li>
        <li>
          <button
            className={styles.navItem}
            aria-current={route === "mindspace" ? "page" : undefined}
            onClick={() => handleNav("mindspace")}
          >
            <BrainIcon
              className={styles.navIcon}
              title="Informații Mindspace"
            />
            Informații Mindspace
          </button>
        </li>
      </ul>

      <div className={styles.mindspaceArea}>
        <MindspaceSelector />
      </div>

      <div className={styles.divider} />

      <div className={styles.historyWrapper}>
        {/* On phone sizes, show history inline within the hamburger sidebar.
            On tablet/desktop, use default behavior. */}
        <ConversationHistory
          overlayMode={
            useMediaQuery("(max-width: 767px)") ? "inlineInSidebar" : null
          }
        />
      </div>

      <footer className={styles.footer}>
        <span>© SMARTERS</span>
      </footer>
    </div>
  );
};

export default AppSidebar;
